export interface ThemeData {
    Id?              :string | ""
    Code            :string
    Description?     :string
    BackgroundImageURL? :string
    FontStyle       :string
    PrimaryAppColor :string
    AccentAppColor  :string
    LandingPageBackgroundURL? :string
    LoginPageBackgroundImageURL?:string
}

export type ThemeResponse = {
    Themes  :ThemeData[] | null,
    Default :string
}


export const NewDefaultTheme : ThemeData = {
    Code : "New Theme",
    FontStyle: "Classic",
    PrimaryAppColor: "Blue",
    AccentAppColor: "Blue",

}